<template>
  <header class="header header--6">
    <!-- <div class="container"> -->
    <div class="navbar d-none d-md-flex">
      <main-nav :isAuth="isAuth" :bookPortal="bookPortal"></main-nav>
      <navbar-logo></navbar-logo>
      <div class="side-menu">
        <a
          v-if="isAuth && !bookPortal"
          :href="$getSubdomainLink('portal', '/books/catalog')"
          class="menu__item"
        >
          Books
        </a>
        <profile-link></profile-link>
        <login-btn></login-btn>
      </div>
    </div>
    <div class="navbar navbar-mobile d-md-none">
      <navbar-logo></navbar-logo>
      <div class="navbar__toggle" @click="toggleMenu">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M3 16.001H21"
            stroke="black"
            stroke-width="1.5"
            stroke-linecap="square"
            stroke-linejoin="round"
          />
          <path
            d="M3 8.00098H21"
            stroke="black"
            stroke-width="1.5"
            stroke-linecap="square"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <div class="menu-box" :class="{ open: isMenuOpen }">
        <!-- <div class="container"> -->
        <div class="menu-box__logo-block">
          <navbar-logo></navbar-logo>
          <div class="navbar__toggle" @click="toggleMenu">
            <svg width="24" height="24">
              <use href="/static/images/sprite/sprite.svg#burger-close"></use>
            </svg>
          </div>
        </div>

        <main-nav :isAuth="isAuth" :bookPortal="bookPortal"></main-nav>
        <div class="sub-menu">
          <a
            v-if="isAuth && !bookPortal"
            :href="$getSubdomainLink('portal', '/books/catalog')"
            class="menu__item"
          >
            Books
          </a>
          <profile-link></profile-link>
        </div>

        <login-btn></login-btn>
        <!-- </div> -->
      </div>
    </div>
    <!-- </div> -->
  </header>
</template>

<script>
import NavbarLogo from './parts/NavbarLogo.vue';
import ProfileLink from './parts/ProfileLink.vue';
import LoginBtn from './parts/LoginBtn.vue';
import MainNav from './parts/MainNav.vue';

export default {
  props: {
    isAuth: {
      type: Boolean,
      required: true,
    },
    bookPortal: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    NavbarLogo,
    ProfileLink,
    LoginBtn,
    MainNav,
  },
  data() {
    return {
      isMenuOpen: false,
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
  },
};
</script>

<style lang="scss">
.header--6 {
  &.header {
    position: relative;
    z-index: 1;
    .navbar {
      padding: 13px 80px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      &__logo {
        width: 40px;
        height: 58px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
      @media (max-width: $breakpoint-lg) {
        padding: 13px 26px;
      }
    }
    .menu {
      display: flex;
      gap: 40px;
      &__item {
        position: relative;
        @include font(16, 400);
        color: $black;
        &:before {
          content: '';
          position: absolute;
          transition: transform 0.5s ease;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 2px;
          background: $red;
          transform: scaleX(0);
        }
        &:hover:before {
          transform: scaleX(1);
        }
      }
    }
    .side-menu {
      display: flex;
      gap: 40px;
      align-items: center;
    }
    .profile-link {
      a {
        position: relative;
        &:before {
          content: '';
          position: absolute;
          transition: transform 0.5s ease;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 2px;
          background: $red;
          transform: scaleX(0);
        }
        &:hover:before {
          transform: scaleX(1);
        }
      }
    }
    @media (max-width: $breakpoint-md) {
      padding: 0 0 12px 0;
      .navbar {
        padding: 4px 16px;
        &__logo {
          width: 28px;
          height: 40px;
          position: static;
          transform: none;
          display: inline-block;
        }
        .menu-box {
          min-height: calc(100vh - 52px);
          width: 100%;
          position: absolute;
          background-color: $white;
          padding: 16px 0;
          top: 100%;
          z-index: 9;
          display: none;
          &.open {
            display: block;
            position: fixed;
            top: 0;
            left: 0;
            padding: 4px 16px;
            .login-btn,
            .logout-btn {
              text-align: center;
            }
            .sub-menu {
              display: flex;
              align-items: center;
              flex-direction: column;
            }
            .menu__item {
              margin-bottom: 7px;
            }
          }
          &__logo-block {
            display: flex;
            justify-content: space-between;
            width: 100%;
          }
        }
        .menu {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 16px;
          border-radius: 20px;
          padding: 24px 20px 0px 20px;
          margin-bottom: 16px;
          li {
            .menu__item {
              font-family: $main-font;
              @include font(16);
              position: relative;
              transition: $transition;
              &.current {
                &:before {
                  content: none;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
